import service from '@/util/service';

// project manager
export const getManager = params => service.jsonGet('/api/business/project/manager/info', params);

export const getManagerList = params => service.jsonGet('/api/business/project/manager/list', params);

export const saveManager = params => service.jsonPost('/api/business/project/manager/save', params);



// WEBPACK FOOTER //
// ./src/api/project/manager.js